import { render, staticRenderFns } from "./TopNavBuilder.vue?vue&type=template&id=6486e892&"
import script from "./TopNavBuilder.vue?vue&type=script&lang=ts&"
export * from "./TopNavBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports